// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavMenuItem_nav-item__BX6Nk {
  font-size: var(--text-base);
  font-weight: 500;
  color: #fff;
  display: flex;
  gap: 1rem;
  align-items: center;
}

.NavMenuItem_nav-item__BX6Nk::before {
  content: "";
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  background-color: var(--gray-semi-light);
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .NavMenuItem_nav-item__BX6Nk {
    font-size: var(--text-sm);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardFooter/Sitemap/Navigation/NavMenu/NavMenuItem/NavMenuItem.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".nav-item {\n  font-size: var(--text-base);\n  font-weight: 500;\n  color: #fff;\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.nav-item::before {\n  content: \"\";\n  width: 0.6rem;\n  height: 0.6rem;\n  border-radius: 50%;\n  background-color: var(--gray-semi-light);\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .nav-item {\n    font-size: var(--text-sm);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav-item": `NavMenuItem_nav-item__BX6Nk`
};
export default ___CSS_LOADER_EXPORT___;
